import { getVehicleRequestStatuses } from '@/utils/api/config'
import { translations } from '@/utils/common'

export default {
  state: {
    vehicleRequestStatuses: {},
    vehicleRequestStatusesSelect: []
  },

  getters: {
    vehicleRequestStatuses(state) {
      return state.vehicleRequestStatuses
    },

    vehicleRequestStatusesSelect(state) {
      return state.vehicleRequestStatusesSelect
    }
  },

  actions: {
    initVehicleRequestStatuses({ commit }) {
      commit('vehicleRequestStatuses/update', getVehicleRequestStatuses())
    }
  },

  mutations: {
    'vehicleRequestStatuses/update'(state, payload) {
      // update vehicleRequestStatuses
      state.vehicleRequestStatuses = payload.reduce((map, es) => {
        map[es.value.toUpperCase()] = {
          ...es,
          text: translations[es.value.toLowerCase()]
        }
        return map
      }, {})

      // update vehicleRequestStatuses for select
      state.vehicleRequestStatusesSelect = payload.map(es => ({
        ...es,
        value: es.value.toUpperCase(),
        text: translations[es.value.toLowerCase()]
      }))
    }
  }
}
